import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const OrderDetails = () => {
  const { orderId, productId } = useParams();
  const [product, setProduct] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [colorMap, setColorMap] = useState({});
  const [sizeMap, setSizeMap] = useState({});

  const user_id = localStorage.getItem("user_id");

  useEffect(() => {
    if (user_id && orderId && productId) {
      fetchOrderDetails();
      fetchColorList();
      fetchSizeList();
    } else {
      setLoading(false);
    }
  }, [orderId, productId]);

  const fetchOrderDetails = async () => {
    try {
      const res = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_new_order",
        { user_id }
      );

      if (res.data.status === "true" || res.data.status === true) {
        const orders = res.data.data || [];
        
        // Find the specific order
        const order = orders.find(o => o.order_id == orderId);
        
        if (order && order.items) {
          // Find the specific product in this order
          const productItem = order.items.find(item => item.product_id == productId);
          
          if (productItem) {
            setProduct(productItem);
            setOrderInfo(order);
          }
        }
      }
    } catch (error) {
      console.error("Order Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchColorList = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_mst_prod_color"
      );

      if (res.data?.status) {
        const map = {};
        res.data.colors.forEach((item) => {
          map[item.color_id] = item.color_name;
        });
        setColorMap(map);
      }
    } catch (err) {
      console.error("Color Fetch Error:", err);
    }
  };

  const fetchSizeList = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_mst_prod_size"
      );

      if (res.data?.status) {
        const map = {};
        res.data.row.forEach((item) => {
          map[item.size_id] = item.size_label;
        });
        setSizeMap(map);
      }
    } catch (err) {
      console.error("Size Fetch Error:", err);
    }
  };

  if (!user_id) {
    return (
      <div className="container py-5 text-center">
        <h5>Please login to view order details</h5>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <h5>Loading order details...</h5>
      </div>
    );
  }

  if (!product || !orderInfo) {
    return (
      <div className="container py-5 text-center">
        <h5>Order not found</h5>
      </div>
    );
  }

  return (
    <div className="order-page container-fluid" style={{marginTop:"115px"}}>
      <div className="row">
        {/* LEFT SECTION */}
        <div className="col-lg-8">
          <div className="card order-card">
            <div className="order-top">
              <p>Pay online for a smooth doorstep experience</p>
              <button className="pay-btn">Pay ₹{product.subtotal || (product.price * product.qty)}</button>
            </div>

            <div className="product-info">
              <div>
                <h5>{product.product_name}</h5>
                <p className="text-muted">
                  {product.color && `${colorMap[product.color] || product.color}`}
                  {product.size && ` | Size: ${sizeMap[product.size] || product.size}`}
                </p>
                <p className="seller">Seller: {product.seller_id ? `Seller ID: ${product.seller_id}` : 'N/A'}</p>
                <h4>₹{product.subtotal || (product.price * product.qty)}</h4>
              </div>

              <div className="product-image">
              <img
                src={
                  product.multi_image
                    ? `https://cyberathon.com/multivendor/${product.multi_image}`
                    : "https://via.placeholder.com/150"
                }
                alt={product.product_name}
              />
              </div>
            </div>

            {/* ORDER TRACKING */}
            <div className="tracking">
              <div className="track active">
                <span></span>
                <p>
                  <strong>Order Confirmed, {orderInfo.order_date}</strong>
                  <br />
                  Your Order has been placed, {orderInfo.created_at}
                </p>
              </div>

              <div className="track">
                <span></span>
                <p>Shipped, Expected by Dec 30</p>
              </div>

              <div className="track">
                <span></span>
                <p>Out For Delivery</p>
              </div>

              <div className="track">
                <span></span>
                <p>Delivery, Jan 02, 2026 by 11 PM</p>
              </div>
            </div>

            <a href="#" className="see-updates">
              See All Updates →
            </a>

            <div className="order-actions">
  {product.order_status === "Delivered" ? (
    <Link to={`/order-return/${orderInfo.order_id}/${product.product_id}`}>
      <button className="btn-outline">Return</button>
    </Link>
  ) : (
    <Link to={`/order-cancel/${orderInfo.order_id}/${product.product_id}`}>
      <button className="btn-outline">Cancel</button>
    </Link>
  )}
</div>

          </div>

          {/* <div className="card simple-card">
            <p>Rate your experience</p>
          </div>

          <div className="card simple-card">
            <p>Send Order Details</p>
          </div> */}
        </div>

        {/* RIGHT SECTION */}
        <div className="col-lg-4">
          <div className="card side-card">
            <h6>Delivery details</h6>
            <p>
              <strong>Home</strong>
              <br />
              {orderInfo.contact_address || 'Address not available'}
            </p>
            <p>
              <strong>{orderInfo.customer_name || orderInfo.contact_name}</strong>
              <br />
              {orderInfo.phone}
            </p>
          </div>

          <div className="card side-card">
            <h6>Price details</h6>

            <div className="price-row">
              <span>Listing price</span>
              <span className="strike">₹{product.price * product.qty}</span>
            </div>

            <div className="price-row">
              <span>Selling price</span>
              <span>₹{product.subtotal || (product.price * product.qty)}</span>
            </div>

            <div className="price-row">
              <span>Quantity</span>
              <span>{product.qty}</span>
            </div>

            <hr />

            <div className="price-row total">
              <span>Total amount</span>
              <span>₹{product.subtotal || (product.price * product.qty)}</span>
            </div>

            <p className="payment">
              Payment method <strong>{orderInfo.payment_mode}</strong>
            </p>
            <p className="payment">
              Payment status <strong className={orderInfo.payment_status === 'Paid' ? 'text-success' : 'text-warning'}>{orderInfo.payment_status}</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;